import { render, staticRenderFns } from "./withdrawsperuser.vue?vue&type=template&id=de313148"
import script from "./withdrawsperuser.vue?vue&type=script&lang=js"
export * from "./withdrawsperuser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports